export const getEmptyTask = () => ({
    comment: "",
    cost: 0,
    quantity: 0,
    unit: "t",
})